import { render, staticRenderFns } from "./DaTeacherPage.vue?vue&type=template&id=5026d786&"
import script from "./DaTeacherPage.vue?vue&type=script&lang=ts&"
export * from "./DaTeacherPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports